import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRight, MapPin } from 'lucide-react';
import { transformations } from '../data/beforeAfter';
import { CompareSlider } from './CompareSlider';
import { Reveal } from './Reveal';
import { Eyebrow } from './Eyebrow';
export function BeforeAfter() {
  const [activeId, setActiveId] = useState(transformations[0].id);
  const active = transformations.find(item => item.id === activeId) ?? transformations[0];
  return <section id="transformations" className="relative overflow-hidden bg-navy-900 py-24 sm:py-32" data-id="element-17" data-mp="3jh6ikpqvsla8">
      <div className="u-grain pointer-events-none absolute inset-0 opacity-60" aria-hidden="true" data-id="element-18" data-mp="34stmztvph4g9" />
      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8" data-id="element-19" data-mp="39rwqvazy94mn">
        <Reveal data-id="element-20" data-mp="2vrc6wbiat2rk">
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-21" data-mp="2vqu8b885ycgh">
            <div className="max-w-2xl" data-id="element-22" data-mp="30qghn6kvf8k0">
              <Eyebrow tone="light" data-id="element-23" data-mp="30pdr4zrgn84m">Before &amp; After</Eyebrow>
              <h2 className="mt-6 font-display text-[clamp(2.1rem,5vw,3.8rem)] leading-[1.02] tracking-[-0.02em] text-white" data-id="element-24" data-mp="x3sfybomr4r3">
                See the <span className="italic text-brass-light" data-id="element-25" data-mp="t2p4e1dm7uvo">Difference.</span>
              </h2>
            </div>
            <p className="max-w-sm text-[15px] leading-relaxed text-white/60" data-id="element-26" data-mp="170ndar962z3s">
              Drag the handle to reveal the transformation. Every project starts with
              thorough prep — that&rsquo;s what makes the finish last.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-27" data-mp="9gss7yy9rp6l">
          <div role="tablist" aria-label="Transformation examples" className="no-scrollbar mt-10 flex gap-2 overflow-x-auto pb-1" data-id="element-28" data-mp="o3vmzxv7jjq8">
            {transformations.map(item => {
            const selected = item.id === activeId;
            return <button key={item.id} role="tab" type="button" aria-selected={selected} onClick={() => setActiveId(item.id)} className={`shrink-0 rounded-full px-5 py-3 text-[11px] font-bold uppercase tracking-[0.16em] transition-all duration-300 ${selected ? 'bg-brass text-navy-900' : 'border border-white/20 text-white/70 hover:border-white/40 hover:text-white'}`} data-id="element-29" data-mp="3mtvthg51oo55">
                  {item.label}
                </button>;
          })}
          </div>
        </Reveal>

        <div className="mt-8 grid items-center gap-10 lg:grid-cols-[1.6fr_1fr]" data-id="element-30" data-mp="1gsjo7qiy05xc">
          <Reveal delay={0.14} data-id="element-31" data-mp="1guo4z91xwzf1">
            <AnimatePresence mode="wait" data-id="element-32" data-mp="1lref7fr2d0sj">
              <motion.div key={active.id} initial={{
              opacity: 0,
              scale: 0.985
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0
            }} transition={{
              duration: 0.5,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-33" data-mp="1lt7qx9gjab7e">
                <CompareSlider before={active.before} after={active.after} alt={active.title} data-id="element-34" data-mp="379f8a1x7vnoy" />
              </motion.div>
            </AnimatePresence>
          </Reveal>

          <Reveal delay={0.2} data-id="element-35" data-mp="2xikk2s0eue0v">
            <div data-id="element-36" data-mp="2tk50ky3jfns7">
              <h3 className="font-display text-3xl leading-tight text-white" data-id="element-37" data-mp="2tik5n7dba2tt">
                {active.title}
              </h3>
              <p className="mt-4 flex items-center gap-2 text-sm text-brass-light" data-id="element-38" data-mp="2oljwgnl60jyh">
                <MapPin className="h-4 w-4" aria-hidden="true" data-id="element-39" data-mp="2jjkw7mkq235r" />
                {active.location}
              </p>
              <p className="mt-6 text-[15px] leading-relaxed text-white/60" data-id="element-40" data-mp="2eo5jixygadax">
                Careful surface preparation, quality materials, and a finish that holds
                up to everyday life in a Kentucky home.
              </p>
              <a href="#contact" className="group mt-9 inline-flex items-center gap-3 rounded-full bg-brass px-8 py-4 text-xs font-bold uppercase tracking-[0.18em] text-navy-900 transition-all duration-300 hover:bg-brass-light hover:shadow-[0_18px_40px_-18px_rgba(192,149,79,1)]" data-id="element-41" data-mp="8sl177vh6bvy">
                Start Your Transformation
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-42" data-mp="6xz16jlm94cp" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}